import store from './store'
import { ATeacher, AUser } from 'kuaidong-api'
import { ISchoolOperateType, ITeacherForm, Teacher, UserRoleInfo } from 'kuaidong-model'
import { getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators'

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'teacher',
})
class TeacherModule extends VuexModule {
  teacher: Teacher | null = null

  userRoleInfo: UserRoleInfo | null = null

  get isAdmin() {
    return !!this.userRoleInfo?.is_admin
  }

  get hasUserAccountPermission() {
    return !!this.teacher?.user_account_permission
  }

  get isPaidSchool() {
    return (
      this.teacher?.school.operate_type === ISchoolOperateType.Paid ||
      this.teacher?.school.operate_type === ISchoolOperateType.PaidExport
    )
  }

  get isVerifiedSchool() {
    return this.teacher?.school.verified
  }

  get isPaidExportSchool() {
    return this.teacher?.school.operate_type === ISchoolOperateType.PaidExport
  }

  get isSportMeetingSchool() {
    return this.teacher?.school_sport_meet
  }

  get buildKey(): (key: string) => string {
    return (key: string) => {
      return `__${this.teacher!.user_id}_${key}__`
    }
  }

  @Mutation
  reset() {
    this.teacher = null
    this.userRoleInfo = null
  }

  @MutationAction
  async loadTeacher() {
    const teacher = await ATeacher.find()
    return { teacher }
  }

  @Mutation
  update(teacherInfo: Partial<Teacher>) {
    this.teacher = {
      ...(this.teacher || ({} as Teacher)),
      ...teacherInfo,
    }
  }

  @Mutation
  updateFromForm(form: ITeacherForm) {
    this.teacher = {
      ...(this.teacher || ({} as any)),
      teacher_name: form.teacher_name,
      head_img_url: form.head_img_url,
      role: form.role,
    }
  }

  @MutationAction
  async loadUserRoleInfo() {
    const userRoleInfo = await AUser.getRoleInfo()
    return { userRoleInfo }
  }
}

export default getModule(TeacherModule)
